module.exports = __webpack_public_path__ + "img/spx_qrcode.3c64e497.jpg";